import React, { createContext, useState } from 'react';
import { HashRouter as Router, Route} from 'react-router-dom';
import Home from './Home';
import ShowCouplet from './ShowCouplet';

const CoupletContext = createContext([{}, () => {}]);

function App() {
  const [couplet, setCouplet] = useState({});
  return (
    <div>
      <CoupletContext.Provider value={[couplet, setCouplet]}>
        <Router>
          <div>
            <Route exact path="/" component={Home} />
            <Route path="/ShowCouplet" component={ShowCouplet} />
          </div>
        </Router>
      </CoupletContext.Provider>
    </div>
  );
}

export default App;
export {CoupletContext};
